export default "__VITE_PUBLIC_ASSET__7afa592f__"